module.exports = {
  "border": {},
  "color": {
    "brand": {
      "orange": {
        "value": "#ff4f00",
        "type": "color",
        "comment": "#FF4F00\n\nPrimary brand color",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#ff4f00ff",
          "type": "color",
          "comment": "#FF4F00\n\nPrimary brand color"
        },
        "name": "ColorBrandOrange",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "orange"
        },
        "path": [
          "color",
          "brand",
          "orange"
        ]
      },
      "earth": {
        "value": "#201515",
        "type": "color",
        "comment": "#201515",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#201515ff",
          "type": "color",
          "comment": "#201515"
        },
        "name": "ColorBrandEarth",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "earth"
        },
        "path": [
          "color",
          "brand",
          "earth"
        ]
      },
      "peach": {
        "value": "#ffbf6e",
        "type": "color",
        "comment": "#FFBF6E",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#ffbf6eff",
          "type": "color",
          "comment": "#FFBF6E"
        },
        "name": "ColorBrandPeach",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "peach"
        },
        "path": [
          "color",
          "brand",
          "peach"
        ]
      },
      "cream": {
        "value": "#fff3e6",
        "type": "color",
        "comment": "#FFF3E6",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#fff3e6ff",
          "type": "color",
          "comment": "#FFF3E6"
        },
        "name": "ColorBrandCream",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "cream"
        },
        "path": [
          "color",
          "brand",
          "cream"
        ]
      },
      "moss": {
        "value": "#1f3121",
        "type": "color",
        "comment": "#1F3121",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#1f3121ff",
          "type": "color",
          "comment": "#1F3121"
        },
        "name": "ColorBrandMoss",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "moss"
        },
        "path": [
          "color",
          "brand",
          "moss"
        ]
      },
      "bolt": {
        "value": "#f6ffdb",
        "type": "color",
        "comment": "#F6FFDB",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#f6ffdbff",
          "type": "color",
          "comment": "#F6FFDB"
        },
        "name": "ColorBrandBolt",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "bolt"
        },
        "path": [
          "color",
          "brand",
          "bolt"
        ]
      },
      "night": {
        "value": "#2b2358",
        "type": "color",
        "comment": "#2B2358",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#2b2358ff",
          "type": "color",
          "comment": "#2B2358"
        },
        "name": "ColorBrandNight",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "night"
        },
        "path": [
          "color",
          "brand",
          "night"
        ]
      },
      "sky": {
        "value": "#cde4e1",
        "type": "color",
        "comment": "#CDE4E1",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#cde4e1ff",
          "type": "color",
          "comment": "#CDE4E1"
        },
        "name": "ColorBrandSky",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "sky"
        },
        "path": [
          "color",
          "brand",
          "sky"
        ]
      },
      "lavender": {
        "value": "#c1b7ff",
        "type": "color",
        "comment": "#C1B7FF",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#c1b7ffff",
          "type": "color",
          "comment": "#C1B7FF"
        },
        "name": "ColorBrandLavender",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "lavender"
        },
        "path": [
          "color",
          "brand",
          "lavender"
        ]
      }
    },
    "neutrals": {
      "neutral800": {
        "value": "#2d2e2e",
        "type": "color",
        "comment": "#2D2E2E • Almost black\n\nUses: Headlines/other text, Primary Icons",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#2d2e2eff",
          "type": "color",
          "comment": "#2D2E2E • Almost black\n\nUses: Headlines/other text, Primary Icons"
        },
        "name": "ColorNeutralsNeutral800",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral800"
        },
        "path": [
          "color",
          "neutrals",
          "neutral800"
        ]
      },
      "neutral700": {
        "value": "#403f3e",
        "type": "color",
        "comment": "#403F3E\n\nUses: Secondary headlines, Body text",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#403f3eff",
          "type": "color",
          "comment": "#403F3E\n\nUses: Secondary headlines, Body text"
        },
        "name": "ColorNeutralsNeutral700",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral700"
        },
        "path": [
          "color",
          "neutrals",
          "neutral700"
        ]
      },
      "neutral600": {
        "value": "#95928e",
        "type": "color",
        "comment": "#95928E\n\nUses: Secondary Icons",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#95928eff",
          "type": "color",
          "comment": "#95928E\n\nUses: Secondary Icons"
        },
        "name": "ColorNeutralsNeutral600",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral600"
        },
        "path": [
          "color",
          "neutrals",
          "neutral600"
        ]
      },
      "neutral500": {
        "value": "#a8a5a0",
        "type": "color",
        "comment": "#A8A5A0\n\nUses: Inactive Text (buttons, inputs)",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#a8a5a0ff",
          "type": "color",
          "comment": "#A8A5A0\n\nUses: Inactive Text (buttons, inputs)"
        },
        "name": "ColorNeutralsNeutral500",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral500"
        },
        "path": [
          "color",
          "neutrals",
          "neutral500"
        ]
      },
      "neutral400": {
        "value": "#d7d5d2",
        "type": "color",
        "comment": "#D7D5D2\n\nUses: Strong Borders",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#d7d5d2ff",
          "type": "color",
          "comment": "#D7D5D2\n\nUses: Strong Borders"
        },
        "name": "ColorNeutralsNeutral400",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral400"
        },
        "path": [
          "color",
          "neutrals",
          "neutral400"
        ]
      },
      "neutral300": {
        "value": "#e8e7e4",
        "type": "color",
        "comment": "#E8E7E4\n\nUses: Soft borders",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#e8e7e4ff",
          "type": "color",
          "comment": "#E8E7E4\n\nUses: Soft borders"
        },
        "name": "ColorNeutralsNeutral300",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral300"
        },
        "path": [
          "color",
          "neutrals",
          "neutral300"
        ]
      },
      "neutral200": {
        "value": "#f7f5f2",
        "type": "color",
        "comment": "#F7F5F2\n\nUses: Inactive Input Background",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#f7f5f2ff",
          "type": "color",
          "comment": "#F7F5F2\n\nUses: Inactive Input Background"
        },
        "name": "ColorNeutralsNeutral200",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral200"
        },
        "path": [
          "color",
          "neutrals",
          "neutral200"
        ]
      },
      "neutral100": {
        "value": "#fffdf9",
        "type": "color",
        "comment": "#FFFDF9 • Almost white\n\nUses: Page and component backgrounds, light text",
        "filePath": "src/tokens/colors.json",
        "isSource": true,
        "original": {
          "value": "#fffdf9ff",
          "type": "color",
          "comment": "#FFFDF9 • Almost white\n\nUses: Page and component backgrounds, light text"
        },
        "name": "ColorNeutralsNeutral100",
        "attributes": {
          "category": "color",
          "type": "neutrals",
          "item": "neutral100"
        },
        "path": [
          "color",
          "neutrals",
          "neutral100"
        ]
      }
    },
    "ui": {
      "action": {
        "blue100": {
          "value": "#f0f1fa",
          "type": "color",
          "comment": "#F0F1FA • Used for expressing state",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#f0f1faff",
            "type": "color",
            "comment": "#F0F1FA • Used for expressing state"
          },
          "name": "ColorUiActionBlue100",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "action",
            "subitem": "blue100"
          },
          "path": [
            "color",
            "ui",
            "action",
            "blue100"
          ]
        },
        "blue600": {
          "value": "#3d4592",
          "type": "color",
          "comment": "#3D4592 • Used for primary actions",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#3d4592ff",
            "type": "color",
            "comment": "#3D4592 • Used for primary actions"
          },
          "name": "ColorUiActionBlue600",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "action",
            "subitem": "blue600"
          },
          "path": [
            "color",
            "ui",
            "action",
            "blue600"
          ]
        },
        "blue200": {
          "value": "#d2d8f3",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#d2d8f3ff",
            "type": "color"
          },
          "name": "ColorUiActionBlue200",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "action",
            "subitem": "blue200"
          },
          "path": [
            "color",
            "ui",
            "action",
            "blue200"
          ]
        },
        "blue300": {
          "value": "#b2bce9",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#b2bce9ff",
            "type": "color"
          },
          "name": "ColorUiActionBlue300",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "action",
            "subitem": "blue300"
          },
          "path": [
            "color",
            "ui",
            "action",
            "blue300"
          ]
        },
        "blue400": {
          "value": "#90a1ed",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#90a1edff",
            "type": "color"
          },
          "name": "ColorUiActionBlue400",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "action",
            "subitem": "blue400"
          },
          "path": [
            "color",
            "ui",
            "action",
            "blue400"
          ]
        },
        "blue500": {
          "value": "#5e71c7",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#5e71c7ff",
            "type": "color"
          },
          "name": "ColorUiActionBlue500",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "action",
            "subitem": "blue500"
          },
          "path": [
            "color",
            "ui",
            "action",
            "blue500"
          ]
        }
      },
      "feedback": {
        "success100": {
          "value": "#def3e9",
          "type": "color",
          "comment": "#DEF3E9",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#def3e9ff",
            "type": "color",
            "comment": "#DEF3E9"
          },
          "name": "ColorUiFeedbackSuccess100",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "success100"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "success100"
          ]
        },
        "success400": {
          "value": "#0f884e",
          "type": "color",
          "comment": "#0F884E",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#0f884eff",
            "type": "color",
            "comment": "#0F884E"
          },
          "name": "ColorUiFeedbackSuccess400",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "success400"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "success400"
          ]
        },
        "success500": {
          "value": "#086f3d",
          "type": "color",
          "comment": "High contrast success backgrounds",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#086f3dff",
            "type": "color",
            "comment": "High contrast success backgrounds"
          },
          "name": "ColorUiFeedbackSuccess500",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "success500"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "success500"
          ]
        },
        "warning100": {
          "value": "#fff4bc",
          "type": "color",
          "comment": "#FFF4BC",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#fff4bcff",
            "type": "color",
            "comment": "#FFF4BC"
          },
          "name": "ColorUiFeedbackWarning100",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "warning100"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "warning100"
          ]
        },
        "warning200": {
          "value": "#fcea93",
          "type": "color",
          "comment": "#FCEA93",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#fcea93ff",
            "type": "color",
            "comment": "#FCEA93"
          },
          "name": "ColorUiFeedbackWarning200",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "warning200"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "warning200"
          ]
        },
        "warning400": {
          "value": "#ffd300",
          "type": "color",
          "comment": "#FFD300",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#ffd300ff",
            "type": "color",
            "comment": "#FFD300"
          },
          "name": "ColorUiFeedbackWarning400",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "warning400"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "warning400"
          ]
        },
        "warning500": {
          "value": "#eec913",
          "type": "color",
          "comment": "#EEC913",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#eec913ff",
            "type": "color",
            "comment": "#EEC913"
          },
          "name": "ColorUiFeedbackWarning500",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "warning500"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "warning500"
          ]
        },
        "error100": {
          "value": "#fadfd9",
          "type": "color",
          "comment": "#FADFD9",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#fadfd9ff",
            "type": "color",
            "comment": "#FADFD9"
          },
          "name": "ColorUiFeedbackError100",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "error100"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "error100"
          ]
        },
        "error400": {
          "value": "#ce482d",
          "type": "color",
          "comment": "#CE482D",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#ce482dff",
            "type": "color",
            "comment": "#CE482D"
          },
          "name": "ColorUiFeedbackError400",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "error400"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "error400"
          ]
        },
        "error500": {
          "value": "#b83519",
          "type": "color",
          "comment": "#B83519",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#b83519ff",
            "type": "color",
            "comment": "#B83519"
          },
          "name": "ColorUiFeedbackError500",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "error500"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "error500"
          ]
        },
        "success200": {
          "value": "#ade2c8",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#ade2c8ff",
            "type": "color"
          },
          "name": "ColorUiFeedbackSuccess200",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "success200"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "success200"
          ]
        },
        "success300": {
          "value": "#36a770",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#36a770ff",
            "type": "color"
          },
          "name": "ColorUiFeedbackSuccess300",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "success300"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "success300"
          ]
        },
        "warning300": {
          "value": "#f8df68",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#f8df68ff",
            "type": "color"
          },
          "name": "ColorUiFeedbackWarning300",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "warning300"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "warning300"
          ]
        },
        "error200": {
          "value": "#feb7a8",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#feb7a8ff",
            "type": "color"
          },
          "name": "ColorUiFeedbackError200",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "error200"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "error200"
          ]
        },
        "error300": {
          "value": "#e87057",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#e87057ff",
            "type": "color"
          },
          "name": "ColorUiFeedbackError300",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "feedback",
            "subitem": "error300"
          },
          "path": [
            "color",
            "ui",
            "feedback",
            "error300"
          ]
        }
      },
      "accent": {
        "pink": {
          "value": "#fad9ef",
          "type": "color",
          "comment": "#FAD9EF",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#fad9efff",
            "type": "color",
            "comment": "#FAD9EF"
          },
          "name": "ColorUiAccentPink",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "accent",
            "subitem": "pink"
          },
          "path": [
            "color",
            "ui",
            "accent",
            "pink"
          ]
        },
        "purple": {
          "value": "#ebd9fa",
          "type": "color",
          "comment": "#EBD9FA",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#ebd9faff",
            "type": "color",
            "comment": "#EBD9FA"
          },
          "name": "ColorUiAccentPurple",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "accent",
            "subitem": "purple"
          },
          "path": [
            "color",
            "ui",
            "accent",
            "purple"
          ]
        },
        "mint": {
          "value": "#d6fcf5",
          "type": "color",
          "filePath": "src/tokens/colors.json",
          "isSource": true,
          "original": {
            "value": "#d6fcf5ff",
            "type": "color"
          },
          "name": "ColorUiAccentMint",
          "attributes": {
            "category": "color",
            "type": "ui",
            "item": "accent",
            "subitem": "mint"
          },
          "path": [
            "color",
            "ui",
            "accent",
            "mint"
          ]
        }
      },
      "semantic": {
        "action": {
          "bg-primary": {
            "value": "#3d4592",
            "type": "color",
            "comment": "Primary UI action color for backgrounds.",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#3d4592ff",
              "type": "color",
              "comment": "Primary UI action color for backgrounds."
            },
            "name": "ColorUiSemanticActionBgPrimary",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "action",
              "state": "bg-primary"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "action",
              "bg-primary"
            ]
          },
          "bg-primary-hover": {
            "value": "#2b2358",
            "type": "color",
            "comment": "Complementary Brand background color used for UI hover states.",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#2b2358ff",
              "type": "color",
              "comment": "Complementary Brand background color used for UI hover states."
            },
            "name": "ColorUiSemanticActionBgPrimaryHover",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "action",
              "state": "bg-primary-hover"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "action",
              "bg-primary-hover"
            ]
          },
          "bg-selected": {
            "value": "#f0f1fa",
            "type": "color",
            "comment": "Soft highlight background color used behind text in menus and navigation elements",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#f0f1faff",
              "type": "color",
              "comment": "Soft highlight background color used behind text in menus and navigation elements"
            },
            "name": "ColorUiSemanticActionBgSelected",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "action",
              "state": "bg-selected"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "action",
              "bg-selected"
            ]
          }
        },
        "feedback": {
          "bg-success": {
            "value": "#def3e9",
            "type": "color",
            "comment": "Soft Success color used for backgrounds like Tag Label",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#def3e9ff",
              "type": "color",
              "comment": "Soft Success color used for backgrounds like Tag Label"
            },
            "name": "ColorUiSemanticFeedbackBgSuccess",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "feedback",
              "state": "bg-success"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "feedback",
              "bg-success"
            ]
          },
          "fg-success": {
            "value": "#0f884e",
            "type": "color",
            "comment": "Primary Success foreground color for icons, alerts, and badges",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#0f884eff",
              "type": "color",
              "comment": "Primary Success foreground color for icons, alerts, and badges"
            },
            "name": "ColorUiSemanticFeedbackFgSuccess",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "feedback",
              "state": "fg-success"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "feedback",
              "fg-success"
            ]
          },
          "bg-warning": {
            "value": "#fff4bc",
            "type": "color",
            "comment": "Soft Warning color used for backgrounds like Tag Label",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#fff4bcff",
              "type": "color",
              "comment": "Soft Warning color used for backgrounds like Tag Label"
            },
            "name": "ColorUiSemanticFeedbackBgWarning",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "feedback",
              "state": "bg-warning"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "feedback",
              "bg-warning"
            ]
          },
          "fg-warning": {
            "value": "#ffd300",
            "type": "color",
            "comment": "Primary Warning foreground color for icons, alerts, and badges",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#ffd300ff",
              "type": "color",
              "comment": "Primary Warning foreground color for icons, alerts, and badges"
            },
            "name": "ColorUiSemanticFeedbackFgWarning",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "feedback",
              "state": "fg-warning"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "feedback",
              "fg-warning"
            ]
          },
          "bg-error": {
            "value": "#fadfd9",
            "type": "color",
            "comment": "Soft Error color used for backgrounds like Tag Label",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#fadfd9ff",
              "type": "color",
              "comment": "Soft Error color used for backgrounds like Tag Label"
            },
            "name": "ColorUiSemanticFeedbackBgError",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "feedback",
              "state": "bg-error"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "feedback",
              "bg-error"
            ]
          },
          "fg-error": {
            "value": "#ce482d",
            "type": "color",
            "comment": "Primary Error foreground color for icons, alerts, and badges",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#ce482dff",
              "type": "color",
              "comment": "Primary Error foreground color for icons, alerts, and badges"
            },
            "name": "ColorUiSemanticFeedbackFgError",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "feedback",
              "state": "fg-error"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "feedback",
              "fg-error"
            ]
          }
        },
        "surface": {
          "bg-primary": {
            "value": "#fffdf9",
            "type": "color",
            "comment": "Page and component backgrounds, light text",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#fffdf9ff",
              "type": "color",
              "comment": "Page and component backgrounds, light text"
            },
            "name": "ColorUiSemanticSurfaceBgPrimary",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "surface",
              "state": "bg-primary"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "surface",
              "bg-primary"
            ]
          },
          "border-subtle": {
            "value": "#e8e7e4",
            "type": "color",
            "comment": "Soft borders",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#e8e7e4ff",
              "type": "color",
              "comment": "Soft borders"
            },
            "name": "ColorUiSemanticSurfaceBorderSubtle",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "surface",
              "state": "border-subtle"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "surface",
              "border-subtle"
            ]
          },
          "border-strong": {
            "value": "#d7d5d2",
            "type": "color",
            "comment": "Strong borders",
            "filePath": "src/tokens/colors.json",
            "isSource": true,
            "original": {
              "value": "#d7d5d2ff",
              "type": "color",
              "comment": "Strong borders"
            },
            "name": "ColorUiSemanticSurfaceBorderStrong",
            "attributes": {
              "category": "color",
              "type": "ui",
              "item": "semantic",
              "subitem": "surface",
              "state": "border-strong"
            },
            "path": [
              "color",
              "ui",
              "semantic",
              "surface",
              "border-strong"
            ]
          }
        }
      }
    }
  },
  "font": {},
  "gradient": {
    "gradients": {
      "carousel-fade": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0.9999999999999999,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf900",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0.9999999999999999,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf900",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientGradientsCarouselFade",
        "attributes": {
          "category": "gradient",
          "type": "gradients",
          "item": "carousel-fade"
        },
        "path": [
          "gradient",
          "gradients",
          "carousel-fade"
        ]
      },
      "modal-fade": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0.9999999999999999,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf980",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0.9999999999999999,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf980",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientGradientsModalFade",
        "attributes": {
          "category": "gradient",
          "type": "gradients",
          "item": "modal-fade"
        },
        "path": [
          "gradient",
          "gradients",
          "modal-fade"
        ]
      }
    },
    "hero": {
      "default-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.4999999690944974,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.49999996909449784,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#403f3eff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5685111880302429,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#403f3eff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.568611204624176,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.4999999690944974,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.49999996909449784,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#403f3eff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5685111880302429,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#403f3eff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.568611204624176,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroDefaultColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero",
          "item": "default-colorblock"
        },
        "path": [
          "gradient",
          "hero",
          "default-colorblock"
        ]
      },
      "zapier-orange-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.49999996833709015,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.49999996833708993,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#ff4f00ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.515625,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#ff4f00ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5157250165939331,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.49999996833709015,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.49999996833708993,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#ff4f00ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.515625,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#ff4f00ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5157250165939331,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroZapierOrangeColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero",
          "item": "zapier-orange-colorblock"
        },
        "path": [
          "gradient",
          "hero",
          "zapier-orange-colorblock"
        ]
      },
      "night-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5000000312512753,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5000000312512753,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#2b2358ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5208333134651184,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#2b2358ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5209333300590515,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5000000312512753,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5000000312512753,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#2b2358ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5208333134651184,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#2b2358ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5209333300590515,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroNightColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero",
          "item": "night-colorblock"
        },
        "path": [
          "gradient",
          "hero",
          "night-colorblock"
        ]
      },
      "almost-black-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.4999999690944974,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.49999996909449784,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#2d2e2eff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5260416865348816,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#2d2e2eff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5261417031288147,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.4999999690944974,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.49999996909449784,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#2d2e2eff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5260416865348816,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#2d2e2eff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5261417031288147,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroAlmostBlackColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero",
          "item": "almost-black-colorblock"
        },
        "path": [
          "gradient",
          "hero",
          "almost-black-colorblock"
        ]
      },
      "moss-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.49999996833709015,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.49999996833708993,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#1f3121ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.515625,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#1f3121ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5157250165939331,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.49999996833709015,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.49999996833708993,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#1f3121ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.515625,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#1f3121ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5157250165939331,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroMossColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero",
          "item": "moss-colorblock"
        },
        "path": [
          "gradient",
          "hero",
          "moss-colorblock"
        ]
      }
    },
    "hero-mobile": {
      "default-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.4999999903236202,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5000000000000001,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 7.90556014267821e-17,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#403f3eff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5790279507637024,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#403f3eff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5791279673576355,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.4999999903236202,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5000000000000001,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 7.90556014267821e-17,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#403f3eff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5790279507637024,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#403f3eff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5791279673576355,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroMobileDefaultColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero-mobile",
          "item": "default-colorblock"
        },
        "path": [
          "gradient",
          "hero-mobile",
          "default-colorblock"
        ]
      },
      "night-colorblock": {
        "value": {
          "to": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.4999999903236202,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 1,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "from": {
            "type": "point",
            "value": {
              "x": {
                "type": "size",
                "value": 0.5000000000000001,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "y": {
                "type": "size",
                "value": 7.90556014267821e-17,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "type": {
            "type": "string",
            "value": "Linear",
            "filePath": "src/tokens/gradients.json",
            "isSource": true
          },
          "aspectRatio": {
            "type": "size"
          },
          "stops": {
            "0": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#2b2358ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "1": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5260416865348816,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#2b2358ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            },
            "2": {
              "type": "gradientStop",
              "position": {
                "type": "size",
                "value": 0.5261417031288147,
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              },
              "color": {
                "type": "color",
                "value": "#fffdf9ff",
                "filePath": "src/tokens/gradients.json",
                "isSource": true
              }
            }
          }
        },
        "type": "gradient",
        "filePath": "src/tokens/gradients.json",
        "isSource": true,
        "original": {
          "value": {
            "to": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.4999999903236202,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 1,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "from": {
              "type": "point",
              "value": {
                "x": {
                  "type": "size",
                  "value": 0.5000000000000001,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "y": {
                  "type": "size",
                  "value": 7.90556014267821e-17,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "type": {
              "type": "string",
              "value": "Linear",
              "filePath": "src/tokens/gradients.json",
              "isSource": true
            },
            "aspectRatio": {
              "type": "size"
            },
            "stops": {
              "0": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#2b2358ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "1": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5260416865348816,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#2b2358ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              },
              "2": {
                "type": "gradientStop",
                "position": {
                  "type": "size",
                  "value": 0.5261417031288147,
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                },
                "color": {
                  "type": "color",
                  "value": "#fffdf9ff",
                  "filePath": "src/tokens/gradients.json",
                  "isSource": true
                }
              }
            }
          },
          "type": "gradient"
        },
        "name": "GradientHeroMobileNightColorblock",
        "attributes": {
          "category": "gradient",
          "type": "hero-mobile",
          "item": "night-colorblock"
        },
        "path": [
          "gradient",
          "hero-mobile",
          "night-colorblock"
        ]
      }
    }
  },
  "measure": {},
  "radius": {},
  "shadow": {
    "button": {
      "value": {
        "color": {
          "type": "color",
          "value": "#00000033",
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "x": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "y": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 5,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "radius": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 10,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "spread": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "opacity": {
          "type": "size",
          "value": 1,
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        }
      },
      "type": "shadow",
      "filePath": "src/tokens/shadows.json",
      "isSource": true,
      "original": {
        "value": {
          "color": {
            "type": "color",
            "value": "#00000033",
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "x": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "y": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 5,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "radius": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 10,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "spread": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "opacity": {
            "type": "size",
            "value": 1,
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          }
        },
        "type": "shadow"
      },
      "name": "ShadowButton",
      "attributes": {
        "category": "shadow",
        "type": "button"
      },
      "path": [
        "shadow",
        "button"
      ]
    },
    "selected": {
      "value": {
        "color": {
          "type": "color",
          "value": "#0000001a",
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "x": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "y": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 5,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "radius": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 10,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "spread": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "opacity": {
          "type": "size",
          "value": 1,
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        }
      },
      "type": "shadow",
      "filePath": "src/tokens/shadows.json",
      "isSource": true,
      "original": {
        "value": {
          "color": {
            "type": "color",
            "value": "#0000001a",
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "x": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "y": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 5,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "radius": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 10,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "spread": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "opacity": {
            "type": "size",
            "value": 1,
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          }
        },
        "type": "shadow"
      },
      "name": "ShadowSelected",
      "attributes": {
        "category": "shadow",
        "type": "selected"
      },
      "path": [
        "shadow",
        "selected"
      ]
    },
    "hover": {
      "value": {
        "color": {
          "type": "color",
          "value": "#0000001a",
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "x": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "y": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 20,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "radius": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 30,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "spread": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "opacity": {
          "type": "size",
          "value": 1,
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        }
      },
      "type": "shadow",
      "filePath": "src/tokens/shadows.json",
      "isSource": true,
      "original": {
        "value": {
          "color": {
            "type": "color",
            "value": "#0000001a",
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "x": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "y": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "radius": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "spread": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "opacity": {
            "type": "size",
            "value": 1,
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          }
        },
        "type": "shadow"
      },
      "name": "ShadowHover",
      "attributes": {
        "category": "shadow",
        "type": "hover"
      },
      "path": [
        "shadow",
        "hover"
      ]
    },
    "dropdown": {
      "value": {
        "color": {
          "type": "color",
          "value": "#00000033",
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "x": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "y": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 10,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "radius": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 30,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "spread": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "opacity": {
          "type": "size",
          "value": 1,
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        }
      },
      "type": "shadow",
      "filePath": "src/tokens/shadows.json",
      "isSource": true,
      "original": {
        "value": {
          "color": {
            "type": "color",
            "value": "#00000033",
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "x": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "y": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 10,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "radius": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "spread": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "opacity": {
            "type": "size",
            "value": 1,
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          }
        },
        "type": "shadow"
      },
      "name": "ShadowDropdown",
      "attributes": {
        "category": "shadow",
        "type": "dropdown"
      },
      "path": [
        "shadow",
        "dropdown"
      ]
    },
    "service-icon": {
      "value": {
        "color": {
          "type": "color",
          "value": "#0000001a",
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "x": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "y": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 5,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "radius": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 10,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "spread": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "opacity": {
          "type": "size",
          "value": 1,
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        }
      },
      "type": "shadow",
      "filePath": "src/tokens/shadows.json",
      "isSource": true,
      "original": {
        "value": {
          "color": {
            "type": "color",
            "value": "#0000001a",
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "x": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "y": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 5,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "radius": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 10,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "spread": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "opacity": {
            "type": "size",
            "value": 1,
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          }
        },
        "type": "shadow"
      },
      "name": "ShadowServiceIcon",
      "attributes": {
        "category": "shadow",
        "type": "service-icon"
      },
      "path": [
        "shadow",
        "service-icon"
      ]
    },
    "tooltip": {
      "value": {
        "color": {
          "type": "color",
          "value": "#0000004d",
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "x": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "y": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 10,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "radius": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 20,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "spread": {
          "type": "measure",
          "value": {
            "measure": {
              "type": "size",
              "value": 0,
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            },
            "unit": {
              "type": "string",
              "value": "pixels",
              "filePath": "src/tokens/shadows.json",
              "isSource": true
            }
          },
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        },
        "opacity": {
          "type": "size",
          "value": 1,
          "filePath": "src/tokens/shadows.json",
          "isSource": true
        }
      },
      "type": "shadow",
      "filePath": "src/tokens/shadows.json",
      "isSource": true,
      "original": {
        "value": {
          "color": {
            "type": "color",
            "value": "#0000004d",
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "x": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "y": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 10,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "radius": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "spread": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/shadows.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          },
          "opacity": {
            "type": "size",
            "value": 1,
            "filePath": "src/tokens/shadows.json",
            "isSource": true
          }
        },
        "type": "shadow"
      },
      "name": "ShadowTooltip",
      "attributes": {
        "category": "shadow",
        "type": "tooltip"
      },
      "path": [
        "shadow",
        "tooltip"
      ]
    }
  },
  "text": {},
  "typography": {
    "headers": {
      "page-header-1": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular Display",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 82,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 1.22,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 84,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular Display",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 82,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 1.22,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 84,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyHeadersPageHeader1",
        "attributes": {
          "category": "typography",
          "type": "headers",
          "item": "page-header-1"
        },
        "path": [
          "typography",
          "headers",
          "page-header-1"
        ]
      },
      "page-header-3": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular Display",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 62,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 1.61,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 66,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular Display",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 62,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 1.61,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 66,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyHeadersPageHeader3",
        "attributes": {
          "category": "typography",
          "type": "headers",
          "item": "page-header-3"
        },
        "path": [
          "typography",
          "headers",
          "page-header-3"
        ]
      },
      "page-header-4": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular Display",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 52,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 1.92,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 60,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular Display",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 52,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 1.92,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 60,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyHeadersPageHeader4",
        "attributes": {
          "category": "typography",
          "type": "headers",
          "item": "page-header-4"
        },
        "path": [
          "typography",
          "headers",
          "page-header-4"
        ]
      },
      "page-header-5": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Semibold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 42,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 50,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Semibold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 42,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 50,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyHeadersPageHeader5",
        "attributes": {
          "category": "typography",
          "type": "headers",
          "item": "page-header-5"
        },
        "path": [
          "typography",
          "headers",
          "page-header-5"
        ]
      },
      "page-header-7": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Semibold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 34,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 40,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Semibold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 34,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 40,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyHeadersPageHeader7",
        "attributes": {
          "category": "typography",
          "type": "headers",
          "item": "page-header-7"
        },
        "path": [
          "typography",
          "headers",
          "page-header-7"
        ]
      },
      "page-header-9": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Semibold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 26,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 32,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Semibold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 26,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 32,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyHeadersPageHeader9",
        "attributes": {
          "category": "typography",
          "type": "headers",
          "item": "page-header-9"
        },
        "path": [
          "typography",
          "headers",
          "page-header-9"
        ]
      }
    },
    "sections": {
      "section-header-1-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 32,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 35,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 32,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 35,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSectionHeader1Medium",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "section-header-1-medium-"
        },
        "path": [
          "typography",
          "sections",
          "section-header-1-medium-"
        ]
      },
      "section-header-1-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 32,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 35,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 32,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 35,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSectionHeader1Bold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "section-header-1-bold-"
        },
        "path": [
          "typography",
          "sections",
          "section-header-1-bold-"
        ]
      },
      "section-header-3-semi-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "SemiBold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "SemiBold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 30,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSectionHeader3SemiBold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "section-header-3-semi-bold-"
        },
        "path": [
          "typography",
          "sections",
          "section-header-3-semi-bold-"
        ]
      },
      "section-header-3-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 30,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSectionHeader3Bold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "section-header-3-bold-"
        },
        "path": [
          "typography",
          "sections",
          "section-header-3-bold-"
        ]
      },
      "subheader-1": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 30,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader1",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-1"
        },
        "path": [
          "typography",
          "sections",
          "subheader-1"
        ]
      },
      "subheader-1-semi-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "SemiBold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "SemiBold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 30,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader1SemiBold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-1-semi-bold-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-1-semi-bold-"
        ]
      },
      "subheader-1-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 30,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 30,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader1Bold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-1-bold-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-1-bold-"
        ]
      },
      "subheader-3-deprecated-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 22,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 28,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 22,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 28,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader3Deprecated",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-3-deprecated-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-3-deprecated-"
        ]
      },
      "subheader-3-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 22,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 28,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 22,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 28,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader3Medium",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-3-medium-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-3-medium-"
        ]
      },
      "subheader-3-semibold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Semibold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 22,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 28,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Semibold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 22,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 28,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader3Semibold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-3-semibold-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-3-semibold-"
        ]
      },
      "subheader-5-deprecated-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 26,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 26,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader5Deprecated",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-5-deprecated-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-5-deprecated-"
        ]
      },
      "subheader-5-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 26,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 26,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader5Medium",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-5-medium-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-5-medium-"
        ]
      },
      "subheader-5-semibold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Degular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Semibold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 26,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Degular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Semibold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 26,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographySectionsSubheader5Semibold",
        "attributes": {
          "category": "typography",
          "type": "sections",
          "item": "subheader-5-semibold-"
        },
        "path": [
          "typography",
          "sections",
          "subheader-5-semibold-"
        ]
      }
    },
    "body": {
      "paragraph-1": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 31,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 31,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1"
        ]
      },
      "paragraph-1-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 31,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 31,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1Medium",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-medium-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-medium-"
        ]
      },
      "paragraph-1-semi-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "SemiBold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 31,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "SemiBold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 31,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1SemiBold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-semi-bold-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-semi-bold-"
        ]
      },
      "paragraph-1-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 31,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 31,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1Bold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-bold-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-bold-"
        ]
      },
      "paragraph-1-short-regular-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1ShortRegular",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-short-regular-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-short-regular-"
        ]
      },
      "paragraph-1-short-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1ShortMedium",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-short-medium-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-short-medium-"
        ]
      },
      "paragraph-1-short-semi-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "SemiBold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "SemiBold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1ShortSemiBold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-short-semi-bold-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-short-semi-bold-"
        ]
      },
      "paragraph-1-short-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 18,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 18,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph1ShortBold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-1-short-bold-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-1-short-bold-"
        ]
      },
      "paragraph-3": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 16,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 16,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph3",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-3"
        },
        "path": [
          "typography",
          "body",
          "paragraph-3"
        ]
      },
      "paragraph-3-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 16,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 16,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph3Medium",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-3-medium-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-3-medium-"
        ]
      },
      "paragraph-3-semi-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "SemiBold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 16,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "SemiBold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 16,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph3SemiBold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-3-semi-bold-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-3-semi-bold-"
        ]
      },
      "paragraph-3-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 16,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 24,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 16,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 24,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodyParagraph3Bold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "paragraph-3-bold-"
        },
        "path": [
          "typography",
          "body",
          "paragraph-3-bold-"
        ]
      },
      "small-print": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Regular",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 14,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Regular",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 14,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodySmallPrint",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "small-print"
        },
        "path": [
          "typography",
          "body",
          "small-print"
        ]
      },
      "small-print-medium-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Medium",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 14,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Medium",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 14,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodySmallPrintMedium",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "small-print-medium-"
        },
        "path": [
          "typography",
          "body",
          "small-print-medium-"
        ]
      },
      "small-print-semi-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "SemiBold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 14,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "SemiBold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 14,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodySmallPrintSemiBold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "small-print-semi-bold-"
        },
        "path": [
          "typography",
          "body",
          "small-print-semi-bold-"
        ]
      },
      "small-print-bold-": {
        "value": {
          "font": {
            "type": "font",
            "value": {
              "family": {
                "type": "string",
                "value": "Inter",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "subfamily": {
                "type": "string",
                "value": "Bold",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "fontSize": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 14,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "textDecoration": "None",
          "textCase": "Original",
          "letterSpacing": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "percent",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "paragraphIndent": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 0,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          },
          "lineHeight": {
            "type": "measure",
            "value": {
              "measure": {
                "type": "size",
                "value": 20,
                "filePath": "src/tokens/typography.json",
                "isSource": true
              },
              "unit": {
                "type": "string",
                "value": "pixels",
                "filePath": "src/tokens/typography.json",
                "isSource": true
              }
            },
            "filePath": "src/tokens/typography.json",
            "isSource": true
          }
        },
        "type": "typography",
        "filePath": "src/tokens/typography.json",
        "isSource": true,
        "original": {
          "value": {
            "font": {
              "type": "font",
              "value": {
                "family": {
                  "type": "string",
                  "value": "Inter",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "subfamily": {
                  "type": "string",
                  "value": "Bold",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "fontSize": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 14,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "textDecoration": "None",
            "textCase": "Original",
            "letterSpacing": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "percent",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "paragraphIndent": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 0,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            },
            "lineHeight": {
              "type": "measure",
              "value": {
                "measure": {
                  "type": "size",
                  "value": 20,
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                },
                "unit": {
                  "type": "string",
                  "value": "pixels",
                  "filePath": "src/tokens/typography.json",
                  "isSource": true
                }
              },
              "filePath": "src/tokens/typography.json",
              "isSource": true
            }
          },
          "type": "typography"
        },
        "name": "TypographyBodySmallPrintBold",
        "attributes": {
          "category": "typography",
          "type": "body",
          "item": "small-print-bold-"
        },
        "path": [
          "typography",
          "body",
          "small-print-bold-"
        ]
      }
    }
  }
};